/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Events deleted from group successfully" |
*
* @param {Context_Menu_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_success_toast = /** @type {((inputs?: Context_Menu_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenements supprimes du groupe avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse erfolgreich aus der Gruppe gelöscht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi eliminati dal gruppo con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События, удаленные из группы, успешно удалены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos eliminados del grupo exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已成功从组中删除事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループからイベントが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह से इवेंट सफलतापूर्वक हटा दिए गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos excluídos do grupo com sucesso")
	return /** @type {LocalizedString} */ ("Events deleted from group successfully")
});